<template>
    <div v-if="links.length > 3">
        <div class="flex flex-wrap -mb-1 pagination-links">
            <template v-for="(link, key) in links">
                <div v-if="link.url === null"
                     :key="key"
                     class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded"
                     v-html="link.label"
                />
                <Link v-else :key="`link-${key}`"
                      class="mb-1 mr-1 px-4 py-3 focus:text-indigo-500 text-sm leading-4 hover:text-indigo-500 border focus:border-indigo-500 rounded"
                      :data-is-active="link.active"
                      :href="link.url"
                      v-html="link.label"
                />
            </template>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
    components: {
        Link,
    },
    props: {
        links: Array,
    },
}
</script>
